import React, { Component } from 'react'
import Link from 'gatsby-link'
import LoneWolfLogo from '../images/lone-wolf-logo.js'

export default class Footer extends Component {
    // If the header is being used in the launchpad, we want to treat all the links
    // as 'external' links so we don't use any browser history features.
    getLink = (to, text, linkArgs = {}) => {
        const { isLaunchpad } = this.props

        return isLaunchpad ? (
            <a href={to}>{text}</a>
        ) : (
            <Link {...linkArgs} getProps={this.isActive} to={to}>
                {text}
            </Link>
        )
    }

    render() {
        return (
            <div className={`footer`}>
                <ul className="footer-link-content">
                    <li>
                        <LoneWolfLogo />
                    </li>
                    <li>
                        <h5>Solutions</h5>
                        <ul>
                            <li>{this.getLink('/agents', 'Agents')}</li>
                            <li>{this.getLink('/teams', 'Teams')}</li>
                            <li>
                                {this.getLink(
                                    '/brokers',
                                    'Brokerages & Franchisors'
                                )}
                            </li>
                            <li>{this.getLink('/mls/connect', 'MLSs')}</li>
                        </ul>
                    </li>
                    <li>
                        <h5>Products</h5>
                        <ul>
                            <li>{this.getLink('/boost', 'Boost')}</li>
                            <li>
                                <a
                                    href={
                                        'https://lonewolf.my.site.com/s/spacio-resources'
                                    }
                                >
                                    Spacio
                                </a>
                            </li>
                            <li>
                                <a
                                    href={
                                        'https://lonewolf.my.site.com/s/connect-resources'
                                    }
                                >
                                    Connect
                                </a>
                            </li>
                            <li>
                                <a
                                    href={
                                        'https://www.lwolf.com/products/leads'
                                    }
                                >
                                    Leads+
                                </a>
                            </li>
                        </ul>
                    </li>
                    <li>
                        <h5>Our Company</h5>
                        <ul>
                            {/* HOLD FOR V2 */}
                            {/* <li>
                                {this.getLink('/reviews', 'Reviews')}
                            </li> */}
                            <li>
                                <a
                                    href={
                                        'https://www.lwolf.com/about/join-the-team'
                                    }
                                >
                                    Careers
                                </a>
                            </li>
                            <li>{this.getLink('/contact', 'Contact')}</li>
                        </ul>
                    </li>
                    <li>
                        <h5>Resources</h5>
                        <ul>
                            <li>{this.getLink('/gethelp', 'Support')}</li>
                            <li>
                                <a href={'http://blog.homespotter.com'}>Blog</a>
                            </li>
                        </ul>
                    </li>
                </ul>
                <div className="footer-bottom">
                    <div className="footer-bottom-content">
                        <div className="footer-bottom-row-1">
                            <div className="footer-join-newsletter">
                                Join our newsletter
                                <form
                                    action="//mobilerealtyapps.us2.list-manage.com/subscribe/post?u=28f7309a5a9e31779069c2a54&id=b9c6c36765"
                                    method="post"
                                    id="mc-embedded-subscribe-form"
                                    name="mc-embedded-subscribe-form"
                                    className="validate newletter-form signup-form form-validation"
                                    target="_blank"
                                    rel="noreferrer"
                                    noValidate
                                >
                                    <select
                                        name="group[20629]"
                                        className="REQ_CSS form-control"
                                        id="mce-group[20629]"
                                        required
                                    >
                                        <option value="">Contact Type</option>
                                        <option value="1">for Agent</option>
                                        <option value="2">for Broker</option>
                                        <option value="4">for MLS</option>
                                    </select>
                                    <div className="join-form-email-submit-group">
                                        <input
                                            title="email"
                                            type="email"
                                            name="EMAIL"
                                            placeholder="Your Email"
                                            className="form-control"
                                            data-required="true"
                                            id="mce-EMAIL"
                                        />
                                        <input
                                            type="submit"
                                            value="Submit"
                                            className="submit"
                                        />
                                        <div
                                            style={{
                                                position: 'absolute',
                                                left: '-5000px',
                                            }}
                                        >
                                            <input
                                                type="text"
                                                name="b_28f7309a5a9e31779069c2a54_10a0eb9814"
                                                tabIndex="-1"
                                                defaultValue=""
                                            />
                                        </div>
                                    </div>
                                </form>
                                <div id="mce-responses" className="clear">
                                    <div
                                        className="response"
                                        id="mce-error-response"
                                        style={{ display: 'none' }}
                                    />
                                    <div
                                        className="response"
                                        id="mce-success-response"
                                        style={{ display: 'none' }}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="footer-bottom-row-2">
                            <div>
                                <span className="copyright">
                                    &copy; {new Date().getFullYear()}{' '}
                                    HomeSpotter LLC, All Rights Reserved
                                </span>
                                <a href="https://www.lwolf.com/website-terms-of-use">
                                    Terms
                                </a>
                                <a href="/privacy">Privacy Policy</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
